export default "__VITE_ASSET__DBZHt1Ks__"